export default "__VITE_ASSET__BtPjOiYZ__"